import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { AuthGuard } from './guards/auth.guard';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { HomeAdminComponent } from './modules/admin/home-admin/home-admin.component';
import { GestHomeComponent } from './modules/gestionnaire/gest-home/gest-home.component';
import { TreatmentComponent } from './components/treatment/treatment/treatment.component';
import { AllergieComponent } from './components/treatment/allergie/allergie.component';
import { ItaComponent } from './components/treatment/ita/ita.component';
import { StaloralComponent } from './components/treatment/staloral/staloral.component';
import { ContreIndicationsComponent } from './components/treatment/contre-indications/contre-indications.component';
import { AdvicesComponent } from './components/treatment/advices/advices.component';
import { LinksComponent } from './components/infos/links/links.component';
import { DocumentationComponent } from './components/infos/documentation/documentation.component';
import { ContactsComponent } from './components/infos/contacts/contacts.component';
import { ToolsComponent } from './components/infos/tools/tools.component';
import { DeliveryComponent } from './components/delivery/delivery.component';
import { SchedulerComponent } from './modules/admin/scheduler/scheduler.component';
import { DetailSchedulerComponent } from './modules/admin/scheduler/detail-scheduler/detail-scheduler.component';
import { ManageUsersComponent } from './modules/admin/manage-users/manage-users.component';
import { PredefinedQueriesComponent } from './modules/admin/predefined-queries/predefined-queries.component';
import { PredefinedQueryResultsComponent } from './modules/admin/predefined-queries/predefined-query-results/predefined-query-results.component';
import { DetailUserComponent } from './modules/admin/manage-users/detail-user/detail-user.component';
import { SupportSujetComponent } from './modules/admin/support-sujet/support-sujet.component';
import { SupportSujetDetailComponent } from './modules/admin/support-sujet/support-sujet-detail/support-sujet-detail.component';
import { SupportComponent } from './components/support/support.component';
import { SupportOfflineComponent } from './components/support-offline/support-offline.component';
import { HomeSupportSujetComponent } from './modules/admin/support-sujet/home-support-sujet.component';
import { MagazineComponent } from './components/magazine/magazine.component';
import { MagazineSingleComponent } from './components/magazine-single/magazine-single.component';

import {MyProfilComponent} from './components/my-profil/my-profil.component';
import {AssociatedProfilesComponent} from './components/associated-profiles/associated-profiles.component';
import {LoginDataComponent} from './components/login-data/login-data.component';
import {DoubleAuthentComponent} from './components/double-authent/double-authent.component';
import { LockedUsersComponent } from './modules/admin/locked-users/locked-users.component';
import { FaqComponent } from './components/faq/faq.component';


const appRoutes: Routes = [
    { path: '', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'forget-password', component: ForgetPasswordComponent },
    { path: 'admin', component: HomeAdminComponent, canActivate: [AuthGuard],
      children: [
        { path: 'manage-users', component: ManageUsersComponent, canActivate: [AuthGuard]},
        { path: 'manage-users/detail-user/:identifiant', component: DetailUserComponent, canActivate: [AuthGuard] },
        { path: 'locked-users', component: LockedUsersComponent, canActivate: [AuthGuard]},
        { path: 'predefined-queries', component: PredefinedQueriesComponent, canActivate: [AuthGuard]},
        { path: 'predefined-queries/predefined-query-results/:queryKey', component: PredefinedQueryResultsComponent, canActivate: [AuthGuard]},
        { path: 'scheduler', component: SchedulerComponent, canActivate: [AuthGuard]},
        { path: 'scheduler/detail-scheduler/:jobName', component: DetailSchedulerComponent, canActivate: [AuthGuard] },
        { path: 'home-support-sujet', component: HomeSupportSujetComponent, canActivate: [AuthGuard],
          children: [
            { path: 'support-sujet-connected', component: SupportSujetComponent,  canActivate: [AuthGuard]},
            { path: 'support-sujet-not-connected', component: SupportSujetComponent,  canActivate: [AuthGuard]},
            { path: 'support-sujet-detail/:key', component: SupportSujetDetailComponent, canActivate: [AuthGuard]}
          ]
        }
      ],
    },
    { path: 'backoffice', component: GestHomeComponent, canActivate: [AuthGuard] },
    { path: 'treatment', component: TreatmentComponent, canActivate: [AuthGuard] },
    { path: 'allergie', component: AllergieComponent, canActivate: [AuthGuard] },
    { path: 'ita', component: ItaComponent, canActivate: [AuthGuard] },
    { path: 'staloral', component: StaloralComponent, canActivate: [AuthGuard] },
    { path: 'contre-indications', component: ContreIndicationsComponent, canActivate: [AuthGuard] },
    { path: 'advices', component: AdvicesComponent, canActivate: [AuthGuard] },
    { path: 'links', component: LinksComponent, canActivate: [AuthGuard] },
    { path: 'documentation', component: DocumentationComponent, canActivate: [AuthGuard] },
    { path: 'contacts', component: ContactsComponent, canActivate: [AuthGuard] },
    { path: 'tools', component: ToolsComponent, canActivate: [AuthGuard] },
    { path: 'delivery', component: DeliveryComponent, canActivate: [AuthGuard] },
    { path: 'double-authent', component: DoubleAuthentComponent, canActivate: [AuthGuard] },
    { path: 'support', component: SupportComponent, canActivate: [AuthGuard] },
    { path: 'support-offline', component: SupportOfflineComponent },
    { path: 'magazine', component: MagazineComponent, canActivate: [AuthGuard] },
    { path: 'magazine/:slug', component: MagazineSingleComponent, canActivate: [AuthGuard] },
    { path: 'my-profil', component: MyProfilComponent, canActivate: [AuthGuard] },
    { path: 'associated-profiles', component: AssociatedProfilesComponent, canActivate: [AuthGuard] },
    { path: 'associated-profiles/:id', component: AssociatedProfilesComponent, canActivate: [AuthGuard] },
    { path: 'login-data', component: LoginDataComponent, canActivate: [AuthGuard] },
    { path: 'faq', component: FaqComponent, canActivate: [AuthGuard] },

    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);
